/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from "react";
import { Box, Button, Modal, Paper, Typography } from "@mui/material";

const style = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  position: "absolute",
  backgroundColor: "#e9e9e9",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.4)",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  overflow: "auto",
  "@media (min-width: 10px)": {
    height: "90vh",
    width: "85vw",
  },
};

export default function SubmissionsByOfficeTypeModal({
  open,
  handleClose,
  modalData,
}) {
  console.log(modalData);

  const { officeType, officeData } = modalData || {};

  return (
    <Modal open={open} onClose={handleClose} disableAutoFocus>
      <Box sx={style}>
        <Box sx={{ mb: 5 }}>
          <Box sx={{ background: "#1e81b0", p: 3, borderRadius: "0 0 0 0" }}>
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: 24,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              }}
            >
              SUBMISSION COUNTS PER OFFICES
            </Typography>
          </Box>

          <Box sx={{ margin: 5 }}>
            <Box>
              {officeType === "Elementary" ? (
                // Render grouped by locationName
                officeData?.length > 0 ? (
                  officeData.map((location, locationIndex) => (
                    <Box key={locationIndex} sx={{ margin: 5 }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: 24,
                          marginBottom: 2,
                        }}
                      >
                        {location.locationName}
                      </Typography>
                      {location.offices.map((office, officeIndex) => (
                        <Paper elevation={5} key={officeIndex} sx={{ mb: 2 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                padding: 5,
                                background: "green",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: "white",
                                  fontWeight: "bold",
                                  fontFamily: "Fira Sans",
                                }}
                              >
                                {office.officeName}
                              </Typography>
                            </Box>
                            <Box sx={{ padding: 5 }}>
                              {office.submissions?.length > 0 ? (
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontFamily: "Fira Sans",
                                  }}
                                >
                                  {office.submissions.length} Accepted Documents
                                </Typography>
                              ) : (
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    fontFamily: "Fira Sans",
                                  }}
                                >
                                  No submissions available.
                                </Typography>
                              )}
                            </Box>
                          </Box>
                        </Paper>
                      ))}
                    </Box>
                  ))
                ) : (
                  <Typography variant="h6" color="textSecondary">
                    No locations available.
                  </Typography>
                )
              ) : // Render offices directly
              officeData?.length > 0 ? (
                officeData.map((office, officeIndex) => (
                  <Box key={officeIndex} sx={{ margin: 5 }}>
                    <Paper elevation={5}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            padding: 5,
                            background: "green",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "white",
                              fontWeight: "bold",
                              fontFamily: "Fira Sans",
                            }}
                          >
                            {office.officeName}
                          </Typography>
                        </Box>
                        <Box sx={{ padding: 5 }}>
                          {office.submissions?.length > 0 ? (
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontFamily: "Fira Sans",
                              }}
                            >
                              {office.submissions.length} Accepted Documents
                            </Typography>
                          ) : (
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                fontFamily: "Fira Sans",
                              }}
                            >
                              No submissions available.
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                ))
              ) : (
                <Typography variant="h6" color="textSecondary">
                  No offices available.
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            m: 5,
            // gap: 2,
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              background: "blue",
              color: "white",
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              borderRadius: "5px",
              boxShadow: "1px 1px 5px rgba(0, 0, 0, 0.5)",
              "&:hover": {
                color: "black",
                backgroundColor: "white",
              },
            }}
          >
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
